import styled from "styled-components";
import { ContainerColumnFlex } from "../ProjectDetails/ProjectDetails.styles";

/** Левая колонка фиксированной ширины: длинные адреса и id не должны сжимать таблицу ролей. */
export const InfoColumn = styled(ContainerColumnFlex)`
  flex: 0 0 440px;
  width: 440px;
  min-width: 0;

  @media (max-width: 1300px) {
    flex: none;
    width: 100%;
  }
`;

export const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.small};
  margin-top: 5px;
`;

export const Muted = styled.span`
  color: ${({ theme }) => theme.colors.textSecondary};
  word-break: break-all;
`;

export const UriList = styled.ul`
  margin: 0;
  padding-left: 20px;
  word-break: break-all;
`;
